import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  panel: {
    backgroundColor: '#FFFFFF',
    textAlign: 'center',
    padding: 27,
    minWidth: 250,
    borderRadius: 16,
  },
  title: {
    fontWeight: 700,
    color: theme.palette.custom.primary1,
    marginTop: 18,
  },
  valueContainer: {
    boxShadow: '0px 10px 50px rgba(182, 185, 199, 0.43)',
    borderRadius: '50%',
    height: 180,
    width: 180,
    margin: 'auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  value: {
    border: `1px solid ${theme.palette.custom.primary1}`,
    height: 163,
    width: 163,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  valueText: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.palette.custom.primary1,
  },
}));

export default useStyles;
